import app from 'flarum/forum/app';
import {ApiResponsePlural} from 'flarum/common/Store';
import Picture from '../models/Picture';

export default class PictureListState {
    params: any
    pictures: Picture[] = []
    moreResults: boolean = false
    loading: boolean = true

    constructor(params: any = {}) {
        this.params = params;
    }

    requestParams() {
        const params: any = {filter: {}};

        params.sort = this.sortMap()[this.params.sort];

        if (this.params.q) {
            params.filter.q = this.params.q;
        }

        return params;
    }

    sortMap() {
        const map: any = {};

        map.latest = '-createdAt';
        map.oldest = 'createdAt';
        map.latestTake = '-takenAt';
        map.oldestTake = 'takenAt';

        return map;
    }

    clear() {
        this.pictures = [];
        m.redraw();
    }

    refresh({deferClear = false} = {}) {
        this.loading = true;

        if (!deferClear) {
            this.clear();
        }

        return this.loadResults().then(
            results => {
                this.pictures = [];
                this.parseResults(results);
            },
            () => {
                this.loading = false;
                m.redraw();
            }
        );
    }

    loadResults(offset = 0): Promise<ApiResponsePlural<Picture>> {
        const preloadedPictures = app.preloadedApiDocument<Picture[]>();

        if (preloadedPictures) {
            return Promise.resolve(preloadedPictures);
        }

        const params = this.requestParams();
        params.page = {offset};

        return app.store.find<Picture[]>('cimaise/pictures', params);
    }

    loadMore() {
        this.loading = true;

        this.loadResults(this.pictures.length)
            .then(this.parseResults.bind(this));
    }

    parseResults(results: ApiResponsePlural<Picture> | Picture[]) {
        this.pictures.push(...results);

        this.loading = false;

        const resultsPayload = (results as ApiResponsePlural<Picture>).payload;
        if (resultsPayload) {
            this.moreResults = !!resultsPayload.links && !!resultsPayload.links.next;
        } else {
            //TODO: when pictures are loaded via the picturesFirstPage relationship, we don't know if there's more
            this.moreResults = results.length >= 24; // Assume false if there's less than 24 results (the number per page)
        }

        m.redraw();

        return results;
    }

    removePicture(picture: Picture) {
        const index = this.pictures.indexOf(picture);

        if (index !== -1) {
            this.pictures.splice(index, 1);
        }
    }

    addPicture(picture: Picture) {
        this.pictures.unshift(picture);
    }
}
